import { createReducer } from 'typesafe-actions';
import { fetchProductsSet } from './actions';

const productsSetInitialState = {
    isLoading: false,
    isError: false,
    errorMessage: null,
    data: null,
};

const productsSetReducer = createReducer(productsSetInitialState)
    .handleAction(fetchProductsSet.request, (state) => ({ ...state, isLoading: true }))
    .handleAction(fetchProductsSet.success, (state, action) => ({
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
    }))
    .handleAction(fetchProductsSet.failure, (state, action) => ({
        ...state,
        isLoading: false,
        isError: true,
        errorMessage: action.payload,
    }));

export default productsSetReducer;
